import { type App } from 'vue';
import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';

// Import/Export the components that you want to use outside of this library.
export { createRoutes } from './routes';

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartials(
            app,
            {
                DecisionMatrix: () => import('./partials/DecisionMatrix.vue'),
                ManageVerificationConfigurations: () =>
                    import('./partials/ManageVerificationConfiguration.vue'),
                NodeDetails: () => import('./partials/NodeDetails.vue'),
                ManageVerificationActions: () =>
                    import('./partials/ManageVerificationActions.vue'),
                ManageVerificationPredicates: () =>
                    import('./partials/ManageVerificationPredicates.vue'),
                CreateVerificationAction: () =>
                    import('./partials/CreateVerificationAction.vue'),
                CreateVerificationRule: () =>
                    import('./partials/CreateVerificationRule.vue'),
                UpdateVerificationRule: () =>
                    import('./partials/UpdateVerificationRule.vue'),
                SetVerificationActions: () =>
                    import('./partials/SetVerificationActions.vue'),
                CreateVerificationPredicateQuestion: () =>
                    import(
                        './partials/CreateVerificationPredicateQuestion.vue'
                    ),
                CreateVerificationConfiguration: () =>
                    import('./partials/CreateVerificationConfiguration.vue'),
            },
            '@precon-tools-suite-by-shared/gino-verification-configurations-feature/partials/'
        );
    },
};
